import { useCallback } from 'react';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import {
  getNextAction,
  getPaymentMethods,
  getSession,
  rememberLink,
  selectPaymentMethod,
  submitConsent,
} from 'Modules/checkout/api';

export const CHECKOUT_KEY = 'v2.checkout';
export const PAYMENT_METHODS_KEY = 'v2.checkout.payment-methods';

const PROCESSING = ['PAYMENT_METHOD_PROCESSING', 'PAYMENT_PROCESSING'];
const PROCESSING_POLL_MS = 5000;

const loadCheckout = async () => {
  const [session, next] = await Promise.all([getSession(), getNextAction()]);
  return { session, next };
};

export const pollWhileProcessing = (data) =>
  PROCESSING.includes(data?.next?.next_action) ? PROCESSING_POLL_MS : false;

export function useCheckout(linkToken) {
  rememberLink(linkToken);
  return useQuery([CHECKOUT_KEY, linkToken], loadCheckout, {
    retry: 0,
    staleTime: 0,
    refetchInterval: pollWhileProcessing,
  });
}

export function usePaymentMethods(linkToken, enabled) {
  return useQuery([PAYMENT_METHODS_KEY, linkToken], getPaymentMethods, {
    retry: 0,
    staleTime: 0,
    enabled,
  });
}

const refreshing = (queryClient, linkToken) => ({
  onSuccess: () => queryClient.invalidateQueries([CHECKOUT_KEY, linkToken]),
});

export function useSelectPaymentMethod(linkToken) {
  const queryClient = useQueryClient();
  return useMutation(selectPaymentMethod, refreshing(queryClient, linkToken));
}

export function useSubmitConsent(linkToken) {
  const queryClient = useQueryClient();
  return useMutation(submitConsent, refreshing(queryClient, linkToken));
}

export function useRefreshCheckout(linkToken) {
  const queryClient = useQueryClient();
  return useCallback(
    () => queryClient.invalidateQueries([CHECKOUT_KEY, linkToken]),
    [queryClient, linkToken]
  );
}
